import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#FDFBF7] font-sans text-[#4A2C40] selection:bg-[#4A2C40] selection:text-[#FDFBF7]" data-id="element-119">
      {/* Navigation */}
      <nav className="py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex justify-between items-center" data-id="element-120">
        <div className="font-serif font-bold text-xl tracking-tight" data-id="element-121">
          The Luteal Survival Kit
        </div>
      </nav>

      <main data-id="element-122">
        <Hero data-id="element-123" />
        <ProblemSection data-id="element-124" />
        <MechanismSection data-id="element-125" />
        <PricingSection data-id="element-126" />
      </main>

      <Footer data-id="element-127" />
    </div>;
}